<div class="flex flex-1 flex-col gap-2">
  @if (printing) {
    <div class="flex flex-1 items-center justify-center">
      <div>
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  }

  @if (!printing && !!printingError) {
    <div class="flex flex-1 items-center justify-center">
      <div class="flex flex-col items-center justify-center gap-4">
        <i class="fa-light fa-print-slash fa-4x"></i>
        <span class="text-slate-900">
          {{ "Anteprima non disponibile" | transloco }}
        </span>
      </div>
    </div>
  }

  @if (!printing && !printingError) {
    <div class="flex flex-1 flex-col rounded-md bg-slate-600 p-8">
      <div
        class="flex flex-col"
        style="max-height: 100%; aspect-ratio: 1 / 1.4142"
      >
        <div class="flex flex-1 flex-col bg-white p-2">
          <div class="flex flex-1">
            <iframe
              [iframeDocumentWrite]="printResult?.content"
              class="flex-1"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  }
</div>
